import { render, staticRenderFns } from "./userCenterTemp.vue?vue&type=template&id=053e3322&scoped=true&"
import script from "./userCenterTemp.vue?vue&type=script&lang=js&"
export * from "./userCenterTemp.vue?vue&type=script&lang=js&"
import style0 from "./userCenterTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./userCenterTemp.vue?vue&type=style&index=1&id=053e3322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e3322",
  null
  
)

component.options.__file = "userCenterTemp.vue"
export default component.exports